import NavHeader from "../shared/Nav-Header";
import { useState, useEffect, useMemo } from "react";
import styles from './group-profile.module.css';
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Notification from '../shared/Notification';
import SocialMessageBox from '../shared/SocialMessageBox';
import defaultProfile2 from '../images/default-profile2.jpg';
import { GROUPAVATARS } from '../shared/avatars/GroupAvatars';
import defaultGroupImage1 from '../images/groups/group-1.png';
import defaultGroupImage2 from '../images/groups/group-2.png';
import { EditIcon, GroupMessageIcon } from '../shared/icons/Icons';
import {formatDistanceToNow, set} from 'date-fns';
import { CopyLinkIcon, LeaveGroupIcon, ReportIcon, DeleteIcon } from '../shared/icons/Icons';
import { useAuth } from '../context/AuthContext';
import SocialSearch from "../shared/SocialSearch";


const GroupProfile = () => {
    const {groupId} = useParams();
    const [group, setGroup] = useState();
    const { userId } = useAuth();
    const [activeGroupChat, setActiveGroupChat] = useState(null);
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();
    const [leaveGroupPopup, setLeaveGroupPopup] = useState(false);
    const [deleteGroupPopup, setDeleteGroupPopup] = useState(false);
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    const [showAddMembers, setShowAddMembers] = useState(false);
    const [selectedNetworks, setSelectedNetworks] = useState([]);
    const [availableNetworks, setAvailableNetworks] = useState([]);
    const [createdDate,setCreatedDate] = useState('');
    const [groupProfilePicturePopup, setGroupProfilePicturePopup] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [closeButton,setCloseButton]= useState(false);
    const [selectedAvatar, setSelectedAvatar] = useState(GROUPAVATARS[0]);
    const [editing, setEditing] = useState(false);
    const [groupProfilePictureView, setGroupProfilePictureView] = useState(false);
    const [showOptions, setShowOptions] = useState(null);
    const [membership, setMembership] = useState('');
    const [leftGroupMembers, setLeftGroupMembers] = useState([])
    // console.log('group',group)
    const [reportGroupPopup, setReportGroupPopup] = useState(false);
    const [reportGroupId, setReportGroupId] = useState(null);
    const [reportMessage, setReportMessage] = useState('');
    const token = useMemo(() => localStorage.getItem('token'), []);
    const socialType = 'group';

    useEffect(() => {
        const fetchGroupDetails = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/login');
                    return;
                }
                const response = await axios.get(`/api/group/group-details/${groupId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log("Group Details Response:", response.data.group);
                setMembership(response.data.membershipStatus);
                setGroup(response.data.group);
                setCreatedDate(formatDistanceToNow(new Date(response.data.group.createdAt), {addSuffix: true}))
            }
            catch (error) {
                const errorMessage = error.response?.data?.message || 'Error fetching group details';
                // console.error(errorMessage);
                setNotification(errorMessage || 'Error fetching group details. Please try again.');
            }
        };
        fetchGroupDetails();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/login');
                    return;
                }

                const response = await axios.get('/api/pn/my-networks', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log("response.data", response.data);
                const projectNetworkList = response.data;
                setProjectNetworkList(projectNetworkList);
                setAvailableNetworks(group ? projectNetworkList.filter(network => !group.participants.some(participant => participant._id === network._id)) : projectNetworkList);
                // console.log("Available Networks:1", availableNetworks);
                // console.log("group:1", group.participants.map(p => p.name));

                // console.log('Project Network List:', projectNetworkList);
            } catch (error) {
                const errorMessage = error.response?.data?.message || 'Error fetching project networks data';
                console.error(errorMessage);
                setNotification(errorMessage ||'Error fetching project networks data. Please try again.');
            }
        };
        fetchData();
    }, [showAddMembers]);

    // useEffect(() => {
    //     if (membership === 'left') {
    //         const fetchLeftGroupMembers =async() =>{
    //             try {
    //                 const response = await axios.get(`/api/group/left-group-members/${group._id}`, {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem('token')}`
    //                     }
    //                 });
    //                 setLeftGroupMembers(response.data.members);
    //                 // console.log("leftGroupMembers:", response.data.members);
    //             }
    //             catch (error) {
    //                 const errorMessage = error.response?.data?.message || 'Error fetching left group members data';
    //                 // console.error(errorMessage);
    //                 setNotification('Error fetching left group members data. Please try again.');
    //             }
    //         }
    //         fetchLeftGroupMembers();
    //     }
    // }, [membership]);

    const handleGroupChatClick = async (group) => {
        if(activeGroupChat){
            setActiveGroupChat(null);
        }
        else{
            setActiveGroupChat(group);
        }
    };
    const handleLeaveGroupClick = async (group) => {
        setLeaveGroupPopup(true);
    };
    
    const handleDeleteGroupClick = async (group) => {
        setDeleteGroupPopup(true);
    };

    const handleAddMembers = async (groupId) => {
        if(selectedNetworks.length === 0) {
            setNotification('Please select at least one member to add.');
            return;
        }
        try {
            const response = await axios.post('/api/group/add-members', {
                groupId,
                userIdsToAdd: selectedNetworks 
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            if (response.data.success) {
                setNotification(response.data.message || 'Member(s) Added successfully!');
                setGroup(response.data.group);
                setSelectedNetworks([])
                setShowAddMembers(false);
                console.log("Updated Group after adding members:", response.data.group);
            }
        } catch (error) {
            // console.error('Error adding members:', error);
            const errorMessage = error.response?.data?.message || 'Error adding members. Please try again.';
            setNotification(errorMessage);
        }
    };
    const handleSelectNetwork = async (event, networkId) => {
        event.stopPropagation();
        setSelectedNetworks((prevSelected) => {
            if (prevSelected.includes(networkId)) {
                return prevSelected.filter(id => id !== networkId);
            } else {
                return [...prevSelected, networkId];
            }
        });
    };
    
    const handleRemoveMember = async (groupId, _id) => {
        try {
            const response = await axios.post('/api/group/remove-member', {
                groupId,
                userIdToRemove:_id
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Member Removed Successfully!');
                setGroup(response.data.group);
                // console.log("Updated Group after removal:", response.data.group);
                setAvailableNetworks(response.data.group ? projectNetworkList.filter(network => !response.data.group.participants.some(participant => participant._id === network._id)) : projectNetworkList);
            }
        } catch (error) {
            // console.error('Error removing member:', error);
            const errorMessage = error.response?.data?.message || 'Error removing member. Please try again.';
            setNotification(errorMessage);
        }
    };
    const handleLeaveGroup = async (groupId) => {
        try {
            const response = await axios.post('/api/group/leave-group', {
                groupId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Group Left successfully!');
                setTimeout(() => {
                    navigate(-1);
                }, 5000);
            }
        } catch (error) {
            // console.error('Error leaving group:', error);
            const errorMessage = error.response?.data?.message || 'Error leaving group. Please try again.';
            setNotification(errorMessage);
        }
    };
    const handleDeleteGroup = async (groupId) => {
        try {
            const response = await axios.post('/api/group/delete-group', {
                groupId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Group Deleted successfully!');
                setTimeout(() => {
                    navigate(-1);
                }, 5000);
            }
        } catch (error) {
            // console.error('Error leaving group:', error);
            const errorMessage = error.response?.data?.message || 'Error deleting group. Please try again.';
            setNotification(errorMessage);
        }
    };

    const confirmDeleteGroup = () => {
        if (group && group._id) {
            handleDeleteGroup(group._id);
        }
        setDeleteGroupPopup(false);
    };
    const cancelDeleteGroup = () => {
        setDeleteGroupPopup(false);
    };

    const handleCloseChat = () => {
        setActiveGroupChat(null);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };

    const confirmLeaveGroup = () => {
        if (group && group._id) {
            handleLeaveGroup(group._id);
        }
        setLeaveGroupPopup(false);
    };
    const cancelLeaveGroup = () => {
        setLeaveGroupPopup(false);
    };

    const handleBack = () => {
        navigate(-1);
    }
    const handleShowAddMembers= () => {
        if(showAddMembers) {
            setShowAddMembers(false);
        } else {
            setShowAddMembers(true);
        }
    };

    const handleSaveGroupInfo = async () => {
        try {
            const response = await axios.post('/api/group/update-group-info', {
                groupId: group._id,
                description: group?.description || "",
                name: group.name
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.data.success) {
                setNotification(response.data.message || 'Group Info Updated successfully!');
                setGroup(response.data.group);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error updating group info. Please try again.';
            setNotification(errorMessage);
            // console.error('Error updating group info:', error);
        }
    };
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (editing) {
                event.preventDefault();
                event.returnValue = 'You have unsaved changes. Do you want to leave?';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [editing]);
    const handleGroupProfilePictureClick =() =>{
        // event.stopPropagation(); // यह event को bubble होने से रोकेगा
        setGroupProfilePictureView(!groupProfilePictureView);
    }
    const handleGroupProfilePictureEdit = () => {
        setGroupProfilePicturePopup(!groupProfilePicturePopup);
        setGroupProfilePictureView(false);
    }
    const handleClickOutside = (event) => {
        if (!event.target.closest(`.${styles.top}`) && 
        !event.target.closest(`.${styles.bottom}`)) {
        setGroupProfilePictureView(false);
    }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [groupProfilePictureView]);
    const handleProfilePictureSelect = async (selectedPicture) => {
        setGroup((prevGroup) => ({
            ...prevGroup,
            profilePicture: selectedPicture
        }));
        setSelectedAvatar(selectedPicture);
        // console.log("selectedPicture:", selectedPicture);

        //preset-upload route
        try{
            const response = await axios.post('/api/group/update-profile-picture', {
                groupId: group._id,
                profilePicture: selectedPicture
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (response.data.success) {
                setNotification(response.data.message || 'Group Profile Picture Updated successfully!');
                setGroup(response.data.group);
                // console.log("Updated Group after profile picture update:", response.data.group);
            }
        } catch (error) {
            const errorMessage = error.message || 'Error updating group profile picture. Please try again.11';
            setNotification(errorMessage);
            // console.error('Error updating profile picture:', error);
        }
        setGroupProfilePicturePopup(false);
    }
    const handleProfileClick = async (networkId) => {
        const profileStatus = 'friends';
        // console.log("profileStatus:hp", profileStatus);
        // setStatus(profileStatus)
        // console.log("status:hp",status)
        navigate(`/profile/${networkId}`, { state: profileStatus });  
    };

    const handleCopyInviteLink = async (e, groupId) => {
        e.preventDefault();
        e.stopPropagation();
        
        try {
            const response = await axios.post('/api/group/invite-link', 
                { groupId },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                const inviteLink = response.data.inviteLink;
                
                await navigator.clipboard.writeText(inviteLink);
                
                const expiresAt = new Date(response.data.expiresAt);
                const now = new Date();
                const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));
                
                setNotification(`Invite link copied to clipboard! Valid for ${daysLeft} days.`);
            }
        } catch (err) {
            console.error('Error generating invite link:', err.message);
            setNotification(err.response?.data?.message || 'Failed to generate invite link. Please try again.');
        }
    };

    const handleReportGroup = async (e, groupId) => {
        e.preventDefault();
        e.stopPropagation();            
        try{
            await axios.post('/api/group/report-group', {
                groupId: groupId,
                reportMessage: reportMessage
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setReportGroupPopup(false);
            setNotification('Group reported. Our team will review it shortly.');
        }
        catch (error) {
            // console.error('Error reporting group:', error);
            const errorMessage = error.response?.data?.message || 'Error reporting group. Please try again.';
            setNotification(errorMessage);
        }
        
    }
    const handleReportGroupPopup = (groupId) => {
        setReportGroupPopup(true);
        setReportGroupId(groupId);
    };
    const cancelReportGroup = () => {
        setReportGroupPopup(false);
    };
    const handleGroupOptions = () => {
        if (showOptions === true) {
            setShowOptions(false);
        } else {
            setShowOptions(true);
        }
    };
    const handleClickOutside2 = (event) => {
            if (!event.target.closest(`.${styles.groupItem}`) && !event.target.closest(`.${styles.messageOptionsMenu}`)) {
                setShowOptions(null);
            }
        };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside2);
        return () => {
            document.removeEventListener('click', handleClickOutside2);
        };
    }, []);
    const handleChange = (e) => {
        // setProfile({ ...profile, [e.target.name]: e.target.value });
    //     setGroup((prevGroup) => ({
        //     ...prevGroup,
        //     profilePicture: selectedPicture
            // }));
    };
    const handleUpload = async (e, type) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'ml_default'); // Replace with your Cloudinary upload preset

        setUploading(true);
        setCloseButton(true);
        try {
            const uploadResponse = await axios.post('/api/upload/upload-all', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            const url = uploadResponse.data.url;

            setGroup((prevGroup) => ({
                ...prevGroup,
                profilePicture: url
            }));

                const response = await axios.post('/api/group/update-profile-picture', {
                    groupId: group._id,
                    profilePicture: url
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                //custom upload route
                if (response.data.success) {
                    setNotification(response.data.message || 'Custom profile picture uploaded successfully!');
                    setGroup(response.data.group);
                }
                
                setUploading(false);
                setCloseButton(false);
                setGroupProfilePicturePopup(false);

            } catch (error) {
                // console.error('Error uploading file:', error);
                const errorMessage = error.response?.data?.message || 'Error uploading file. Please try again.';
                setNotification(errorMessage);
                setUploading(false);
            }
        };
    
//    console.log("groupparticipats", group?.participants.map( _id => _id.name));
    //             console.log("Available Networks:2", availableNetworks);
        // console.log("group.admin:", group?.admin, "userId:", userId);
    return (
        <div>
            <NavHeader />
            <br/><br/>
            <br/><br/>
            <h1>Group Profile</h1>
            {notification && (
                    <Notification message={notification} onClose={handleCloseNotification} />
                )}
            {membership == 'member'&&(
                <>
                {group &&
                    <div className={styles.groupProfileContainer}>
                        <img 
                            title={group.name} 
                            onClick={()=> handleGroupProfilePictureClick()} 
                            src={group.profilePicture ? group.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultGroupImage2}alt="pfp" 
                            className={`${styles.networkProfilePicture} ${styles.top}`} 
                        />
                        {!editing && <h2 className={styles.groupName}>{group.name}</h2>}
                        
                        <div className={styles.groupItem} onClick={() => {handleGroupOptions()}}>
                            <button 
                                className={styles.threeDotsButton} 
                                 
                                title="options"
                            >
                                ⋮
                            </button>

                            {showOptions === true && (
                                <div className={styles.messageOptionsMenu}>
                                    <button 
                                    onClick={(e) => 
                                    {handleCopyInviteLink(e, group._id);setShowOptions(null)}}>
                                        <CopyLinkIcon/>
                                        Copy Invite Link
                                    </button>

                                    {membership==='member' && <button 
                                        onClick={() => 
                                        {handleLeaveGroup(group._id);setShowOptions(null)}}>
                                            <LeaveGroupIcon/>
                                            Leave Group
                                        </button>
                                    }
                                    <button 
                                    onClick={() => {handleReportGroupPopup(group._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Report Group
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className={styles.bottom}>
                            {groupProfilePictureView && (
                                <div className={ styles.groupProfilePictureViewOverlay}>
                                    <h3>{group.name}</h3>
                                    <img 
                                        title={group.name} 
                                        src={group.profilePicture ? group.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultGroupImage2}alt="pfp" 
                                        className={styles.networkProfilePictureLarge} 
                                    />
                                    {group.admin == userId &&( 
                                    <p onClick={()=>handleGroupProfilePictureEdit()} >
                                        <EditIcon className={styles.editGroupDescriptionIcon}/>
                                    </p>)}
                                    <button onClick={()=>handleGroupProfilePictureClick()} className={styles.closeProfilePictureViewButton}>Close</button>
                                </div>
                            )}  
                        </div>

                            
                        {editing ?
                            (<div className={styles.editDescriptionContainer}>
                                <input
                                type="text"
                                className={styles.groupNameInput}
                                value={group.name || ""}
                                onChange={(e) => setGroup({ ...group, name: e.target.value })}
                                placeholder="Enter group name..."
                            />
                                <textarea
                                    className={styles.descriptionTextarea}
                                    value={group?.description || ""}
                                    onChange={(e) => setGroup({ ...group, description: e.target.value })}
                                    placeholder="Enter group description..."
                                />
                                <div className={styles.descriptionButtons}>
                                    <button 
                                        className={styles.cancelDescriptionButton}
                                        onClick={() => setEditing(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        className={styles.saveDescriptionButton}
                                        onClick={() => {setEditing(false);handleSaveGroupInfo()}}
                                    >
                                        Save
                                    </button>
                                    </div>
                            </div>)
                            :
                            (
                                <>
                                <p className={styles.groupDescription}>{group.description || "No description Info"}
                                </p>
                                {group.admin == userId &&( 
                                <p  className={styles.editGroupDescriptionIcon} onClick={()=>setEditing(!editing)} >
                                    <EditIcon/>
                                </p>)}
                                </>
                            )
                        }

                        {groupProfilePicturePopup && (
                                <div>
                                    <h3>Select Avatar</h3>
                                    <div className={styles.profilePictureGrid}>
                                        {GROUPAVATARS.map((defaultGroupImage, index) => (
                                            <img 
                                                key={index}
                                                src={defaultGroupImage} 
                                                alt={`Avatar ${index + 1}`} 
                                                onClick={() => handleProfilePictureSelect(defaultGroupImage)} 
                                                className={styles.gridImage}
                                            />
                                        ))}
                                    </div>

                                    <div className={styles.profileInfo}>
                                        <label>Custom Upload</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'profilePicture')}
                                            className={styles.imageUploadInput}
                                        />
                                        {uploading && <p>Uploading...</p>}
                                    </div>
                                    
                                    <div className={styles.groupProfilePicturePopupCloseButton}>
                                        <button onClick={() => setGroupProfilePicturePopup(false)} disabled={closeButton} className={styles.groupProfilePicturePopupCloseButton}>Close</button>
                                    </div>
                                </div>
                        )}
                        
                        <span className={styles.groupCreated}>Created: {createdDate}</span>
                        <div className={styles.networkActions}>
                            <button onClick={() => handleGroupChatClick(group)} className={styles.primaryAction}>
                                <GroupMessageIcon /> 
                                <p> Say Hi! </p>
                            </button>
                            <button onClick={() => handleLeaveGroupClick(group._id)} className={styles.secondaryAction}>
                                😢Leave Group
                            </button>
                                        <button className={styles.secondaryAction} onClick={() => handleBack()} > Go Back </button>
                            <br/><br/>
                        </div> 
                        
                        <div className={styles.sectionTitle}>
                            <h3 >  </h3>
                            <h3 className={styles.sectionTitleParticipantsNumber}> {group.participants.length} </h3>
                            <h3 >Members</h3>
                        </div>

                        <SocialSearch socialType='group' socialId={groupId}/>

                        {group.admin == userId ? (
                            <ul className={styles.memberList}>
                                {group.participants.map((member, index) => (
                                    <>
                                        <li key={member} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                            <img title={member.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                        <p>{member.name}</p>
                                            </li>
                                        <button onClick={() => handleRemoveMember(group._id, member._id)} className={styles.removeMemberButton} aria-label={`Remove ${member.name} from group`} title="Remove member">
                                            X
                                        </button>
                                    </>
                                ))}
                            </ul>
                            ) : (
                            <ul className={styles.memberList}>
                                {group.participants.map((member, index) => (
                                    <li key={member._id?.toString()} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                        <img title={member._id?.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                        <p>{member.name}</p>
                                        </li>
                                ))}
                            </ul>
                        )}

                        {group.admin == userId ? (
                            <button onClick={handleShowAddMembers} className={styles.addMembers}>
                                Add Members
                            </button>
                        ) : null}

                        {showAddMembers && (
                            <div className={styles.mainContent}>
                                <div className={styles.leftColumn}>
                                    <div className={styles.groupCreationForm}>
                                        <h4>🌈 Adding {selectedNetworks.length} New Member(s) to {group.name}🌈</h4>
                                        <button onClick={()=>handleAddMembers(group._id)} className={styles.createButton}>
                                            🎊 Add Selected Members! 🎊
                                        </button>
                                        <button onClick={handleShowAddMembers} className={styles.closeCreateGroupButton}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                                <div className={styles.rightColumn}>
                                    {(availableNetworks || availableNetworks.length !== 0) &&  (
                                        <div className={`${styles.networksSection} ${styles.pnGroup}`}>
                                            <h3>Add Friends</h3>
                                            <ul>
                                                {availableNetworks?.map(network => (
                                                    <li key={network._id} className={styles.networkItem} 
                                                    onClick={(e) => handleSelectNetwork(e, network._id)}
                                                    >
                                                        <div className={styles.networkInfo} >
                                                            <img title={network.name} src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                                            <span className={styles.networkName}>💫 {network.name} 💫</span>
                                                            <span className={styles.connectionTime}>{network.skills}</span>
                                                            <input type="checkbox" checked={selectedNetworks.includes(network._id)}/>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            {(!availableNetworks || availableNetworks.length === 0) && (
                                            <div className={styles.emptyState}>
                                                <p>🥺All Your Connection are in this group? Let's find some amazing people to connect with! 🥺</p>
                                            </div> 
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        
                    </div>
                }
                {leaveGroupPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Confirm Leave Group</h2>
                            <p>Are you sure you want to leave this group?</p>
                            <div className={styles.popupActions}>
                                <button onClick={confirmLeaveGroup} className={styles.confirmButton}>Yes, Leave</button>
                                <button onClick={cancelLeaveGroup} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {activeGroupChat && (
                    <SocialMessageBox socialType={socialType} social={activeGroupChat} onClose={handleCloseChat} />
                )}
                </>
            )}
            {membership == 'left'&&(
                <>
                {group &&
                    <div className={styles.groupProfileContainer}>
                        <img 
                            title={group.name} 
                            onClick={()=> handleGroupProfilePictureClick()} 
                            src={group.profilePicture ? group.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultGroupImage2}alt="pfp" 
                            className={`${styles.networkProfilePicture} ${styles.top}`} 
                        />
                        <h2 className={styles.groupName}>{group.name}</h2>
                        
                        <div className={styles.groupItem} onClick={() => {handleGroupOptions()}}>
                            <button 
                                className={styles.threeDotsButton} 
                                 
                                title="options"
                            >
                                ⋮
                            </button>

                            {showOptions === true && (
                                <div className={styles.messageOptionsMenu}>
                                    <button 
                                    onClick={(e) => 
                                    {handleCopyInviteLink(e, group._id);setShowOptions(null)}}>
                                        <CopyLinkIcon/>
                                        Copy Invite Link
                                    </button>
                                    {membership==='left' && <button 
                                        onClick={() => 
                                        {handleDeleteGroup(group._id);setShowOptions(null)}}>
                                            <DeleteIcon/>
                                            Delete Group
                                        </button>
                                    }
                                    <button 
                                    onClick={() => {handleReportGroupPopup(group._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Report Group
                                    </button>
                                </div>
                            )}
                            </div>
                        <div className={styles.bottom}>
                            {groupProfilePictureView && (
                                <div className={ styles.groupProfilePictureViewOverlay}>
                                    <h3>{group.name}</h3>
                                    <img 
                                        title={group.name} 
                                        src={group.profilePicture ? group.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultGroupImage2}alt="pfp" 
                                        className={styles.networkProfilePictureLarge} 
                                    />
                                    <button onClick={()=>handleGroupProfilePictureClick()} className={styles.closeProfilePictureViewButton}>Close</button>
                                </div>
                            )}  
                        </div>

                        <p className={styles.groupDescription}>{group.description || "No description Info"}
                        </p>
                        
                        <span className={styles.groupCreated}>Created: {createdDate}</span>
                        <div className={styles.networkActions}>
                            <button onClick={() => handleGroupChatClick(group)} className={styles.primaryAction}>
                                <GroupMessageIcon /> 
                                <p> Say Hi! </p>
                            </button>
                            <button onClick={() => handleDeleteGroupClick(group._id)} className={styles.secondaryAction}>
                                Delete Group
                            </button>
                                        <button className={styles.secondaryAction} onClick={() => handleBack()} > Go Back </button>
                            <br/><br/>
                        </div> 
                        
                        <div className={styles.sectionTitle}>
                            <h3 >  </h3>
                            <h3 className={styles.sectionTitleParticipantsNumber}> {group.participants.length} </h3>
                            <h3 >Previous Members</h3>
                        </div> 
                            <ul className={styles.memberList}>
                                {leftGroupMembers.map((member, index) => (
                                    <li key={member._id?.toString()} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                        <img title={member.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                        <p>{member.name}</p>
                                        </li>
                                ))}
                            </ul>
                    </div>
                }
                {deleteGroupPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Confirm Delete Group</h2>
                            <p>Are you sure you want to delete this group?</p>
                            <div className={styles.popupActions}>
                                <button onClick={confirmDeleteGroup} className={styles.confirmButton}>Yes, Delete</button>
                                <button onClick={cancelDeleteGroup} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {/* {activeGroupChat && (
                    <SocialMessageBox socialType={socialType} social={activeGroupChat} onClose={handleCloseChat} />
                )} */}
                </>
            )}
            {reportGroupPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Reporting Group</h2>
                            <p>Thanks, Reported Group are reviewed shortly.</p>
                                <textArea
                                    type="text"
                                    value={reportMessage}
                                    onChange={(e) => setReportMessage(e.target.value)}
                                    placeholder="Report Message (Optional)"
                                    className={styles.reportMessageInput}
                                />
                            <div className={styles.popupActions}>
                                <button onClick={(e)=>handleReportGroup(e, reportGroupId)} className={styles.confirmButton}>Report</button>
                                <button onClick={cancelReportGroup} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    );
}
export default GroupProfile;